import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import type { Moment } from "moment";
import { ExcelButton } from "@/controls/buttons/ExcelButton";

interface Props {
	start: Moment;
	end: Moment;
	onStartChange: (date: Moment | null) => void;
	onEndChange: (date: Moment | null) => void;
	onLastTwelveMonths: () => void;
	onReset: () => void;
	onExportExcel: () => void;
	isLoading: boolean;
}

export const ProductTypesStatisticsToolbar = ({
	start,
	end,
	onStartChange,
	onEndChange,
	onLastTwelveMonths,
	onReset,
	onExportExcel,
	isLoading,
}: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="Start"
					format="MM/DD/YYYY"
					value={start}
					maxDate={end}
					onChange={onStartChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="End"
					format="MM/DD/YYYY"
					value={end}
					minDate={start}
					onChange={onEndChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>

			<Button size="small" variant="contained" onClick={onLastTwelveMonths}>
				Last 12 Months
			</Button>

			{/* Changing a date already refetches, so a search button would have nothing to
			    do. This one puts the range back to the window the screen opens on and
			    reloads it, which is also how you pick up campaigns closed since the page
			    was opened — the report does not poll. */}
			<Tooltip title="Reset to the default range">
				<span>
					<IconButton
						onClick={onReset}
						disabled={isLoading}
						size="small"
						sx={{
							bgcolor: "primary.main",
							color: "white",
							width: 28,
							height: 28,
							"&:hover": { bgcolor: "primary.dark" },
							"&.Mui-disabled": {
								bgcolor: "action.disabledBackground",
								color: "action.disabled",
							},
						}}
					>
						<RestartAltIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</span>
			</Tooltip>

			<Box sx={{ flexGrow: 1, minWidth: 8 }} />

			<Box sx={{ width: 200 }}>
				<ExcelButton handleExportToExcel={onExportExcel} />
			</Box>
		</Box>
	);
};
